// Module
var code = `<survey-modal platforms="vm.platforms" survey-manager="vm.surveyManager" ng-if="vm.showUpdateEmailSurvey" current-email="vm.currentEmail" participant-id="participantId"/> `;
// Exports
export default code;